export default class RecurringTask {
  constructor(id, name, description, date) {
    this.id = id
    this.name = name
    this.description = description
    this.date = date
  }
}
